// Static concentration-risk graph SVG — hardcoded markup, no user input.
// Mirrors the visual style of OwnershipGraphCard.svg.ts.

export const CONCENTRATION_GRAPH_SVG = String.raw`<svg viewBox="0 0 640 360" xmlns="http://www.w3.org/2000/svg" font-family="DM Sans, Poppins, sans-serif" aria-hidden="true" width="100%" height="100%">
<defs>
  <clipPath id="ccf15"><circle r="15"/></clipPath>
  <clipPath id="ccf20"><circle r="20"/></clipPath>
  <!-- GB flag -->
  <g id="cc-flag-gb"><g clip-path="url(#ccf15)">
    <rect x="-15" y="-15" width="30" height="30" fill="#012169"/>
    <path d="M-15-15L15 15M15-15L-15 15" stroke="#fff" stroke-width="8"/>
    <path d="M-15-15L15 15M15-15L-15 15" stroke="#C8102E" stroke-width="3.6"/>
    <path d="M0-15V15M-15 0H15" stroke="#fff" stroke-width="9.6"/>
    <path d="M0-15V15M-15 0H15" stroke="#C8102E" stroke-width="5.4"/>
  </g></g>
  <!-- NL flag -->
  <g id="cc-flag-nl"><g clip-path="url(#ccf15)">
    <rect x="-15" y="-15" width="30" height="10" fill="#AE1C28"/>
    <rect x="-15" y="-5" width="30" height="10" fill="#fff"/>
    <rect x="-15" y="5" width="30" height="10" fill="#21468B"/>
  </g></g>
  <!-- NL flag large -->
  <g id="cc-flag-nl-lg"><g clip-path="url(#ccf20)">
    <rect x="-20" y="-20" width="40" height="13.3" fill="#AE1C28"/>
    <rect x="-20" y="-6.7" width="40" height="13.3" fill="#fff"/>
    <rect x="-20" y="6.7" width="40" height="13.3" fill="#21468B"/>
  </g></g>
</defs>

<!-- Edge: parent → left supplier -->
<line class="ge" pathLength="1" x1="320" y1="105" x2="120" y2="255" stroke="#c6d2e4" stroke-width="1.5" style="animation-delay:0.3s"/>
<!-- Edge label -->
<g class="gn" style="animation-delay:0.55s"><rect x="166" y="159" rx="10" width="72" height="22" fill="#f3f6fb"/><text x="202" y="174" font-size="11" font-weight="600" fill="#5b6b83" text-anchor="middle">PSC · 78%</text></g>

<!-- Edge: parent → center supplier -->
<line class="ge" pathLength="1" x1="320" y1="105" x2="320" y2="255" stroke="#c6d2e4" stroke-width="1.5" style="animation-delay:0.5s"/>
<g class="gn" style="animation-delay:0.75s"><rect x="284" y="172" rx="10" width="72" height="22" fill="#f3f6fb"/><text x="320" y="187" font-size="11" font-weight="600" fill="#5b6b83" text-anchor="middle">PSC · 55%</text></g>

<!-- Edge: parent → right supplier -->
<line class="ge" pathLength="1" x1="320" y1="105" x2="520" y2="255" stroke="#c6d2e4" stroke-width="1.5" style="animation-delay:0.7s"/>
<g class="gn" style="animation-delay:0.95s"><rect x="398" y="159" rx="10" width="72" height="22" fill="#f3f6fb"/><text x="434" y="174" font-size="11" font-weight="600" fill="#5b6b83" text-anchor="middle">PSC · 91%</text></g>

<!-- Parent node: Vanta Holdings BV -->
<g class="gn" style="animation-delay:0.1s">
  <circle cx="320" cy="75" r="26" fill="none" stroke="#2b3af7" opacity="0">
    <animate attributeName="r" values="26;52" begin="2.5s" dur="2s" repeatCount="indefinite"/>
    <animate attributeName="opacity" values=".35;0" begin="2.5s" dur="2s" repeatCount="indefinite"/>
  </circle>
  <circle cx="320" cy="75" r="30" fill="#fff" stroke="#e3e9f2" stroke-width="1.3"/>
  <circle cx="320" cy="75" r="24" fill="none" stroke="#2b3af7" stroke-width="2.2"/>
  <use href="#cc-flag-nl-lg" x="320" y="75"/>
  <text x="320" y="30" font-family="Poppins, sans-serif" font-size="12" font-weight="700" fill="#0c1930" text-anchor="middle">VANTA HOLDINGS BV</text>
  <text x="320" y="46" font-size="10.5" font-weight="400" fill="#5b6b83" text-anchor="middle">Netherlands · UBO</text>
</g>

<!-- Sanctions badge on parent -->
<g class="gn" style="animation-delay:0.2s">
  <rect x="253" y="108" rx="10" width="134" height="20" fill="rgba(214,60,60,0.1)" stroke="rgba(214,60,60,0.3)" stroke-width="1"/>
  <text x="320" y="122" font-size="10.5" font-weight="600" fill="#c0392b" text-anchor="middle">⚠ Sanctions exposure</text>
</g>

<!-- Left supplier: Northgate Castings Ltd -->
<g class="gn" style="animation-delay:0.85s">
  <circle cx="120" cy="278" r="21" fill="#fff" stroke="#e3e9f2" stroke-width="1.3"/>
  <use href="#cc-flag-gb" x="120" y="278"/>
  <text x="120" y="316" font-size="11" font-weight="600" fill="#0c1930" text-anchor="middle">Northgate Castings Ltd</text>
  <text x="120" y="330" font-size="10" fill="#5b6b83" text-anchor="middle">United Kingdom</text>
</g>

<!-- Center supplier: Anvil Precision BV -->
<g class="gn" style="animation-delay:1.0s">
  <circle cx="320" cy="278" r="21" fill="#fff" stroke="#e3e9f2" stroke-width="1.3"/>
  <use href="#cc-flag-nl" x="320" y="278"/>
  <text x="320" y="316" font-size="11" font-weight="600" fill="#0c1930" text-anchor="middle">Anvil Precision BV</text>
  <text x="320" y="330" font-size="10" fill="#5b6b83" text-anchor="middle">Netherlands</text>
</g>

<!-- Right supplier: Meridian Components Ltd -->
<g class="gn" style="animation-delay:1.15s">
  <circle cx="520" cy="278" r="21" fill="#fff" stroke="#e3e9f2" stroke-width="1.3"/>
  <use href="#cc-flag-gb" x="520" y="278"/>
  <text x="520" y="316" font-size="11" font-weight="600" fill="#0c1930" text-anchor="middle">Meridian Components Ltd</text>
  <text x="520" y="330" font-size="10" fill="#5b6b83" text-anchor="middle">United Kingdom</text>
</g>

<!-- Animated dots along edges -->
<circle r="3.5" fill="#2b3af7" opacity="0">
  <animateMotion path="M320 105L120 255" begin="2.0s" dur="1.8s" repeatCount="indefinite"/>
  <animate attributeName="opacity" values="0;.85;0" begin="2.0s" dur="1.8s" repeatCount="indefinite"/>
</circle>
<circle r="3.5" fill="#2b3af7" opacity="0">
  <animateMotion path="M320 105L320 255" begin="2.6s" dur="1.8s" repeatCount="indefinite"/>
  <animate attributeName="opacity" values="0;.85;0" begin="2.6s" dur="1.8s" repeatCount="indefinite"/>
</circle>
<circle r="3.5" fill="#2b3af7" opacity="0">
  <animateMotion path="M320 105L520 255" begin="3.2s" dur="1.8s" repeatCount="indefinite"/>
  <animate attributeName="opacity" values="0;.85;0" begin="3.2s" dur="1.8s" repeatCount="indefinite"/>
</circle>
</svg>`;
